import { render, staticRenderFns } from "./stemdo-components.component.vue?vue&type=template&id=1ec3d7d0"
import script from "./stemdo-components.component.ts?vue&type=script&lang=ts&external"
export * from "./stemdo-components.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ec3d7d0')) {
      api.createRecord('1ec3d7d0', component.options)
    } else {
      api.reload('1ec3d7d0', component.options)
    }
    module.hot.accept("./stemdo-components.component.vue?vue&type=template&id=1ec3d7d0", function () {
      api.rerender('1ec3d7d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/components/stemdo-components/stemdo-components.component.vue"
export default component.exports